import React, { FunctionComponent } from 'react';
import App from '../App';

interface MainProps {}

const Main: FunctionComponent<MainProps> = () => {
    return <App />;
};

export default Main;
